import { Area } from "./types";

const keys = {
  all: () => ["areas"] as const,
  one: (id: Area["_id"]) => [...keys.all(), id] as const,
};

export default keys;
